// extracted by mini-css-extract-plugin
export default {"badge":"engagement_roles_badge-module___badge___cd417f27"};